import { FacetStats } from '@api-client/src/api/types';

const getFacetStats = (response: any, facetName: string): FacetStats | undefined => {
  const facetStats = response?.results?.[0]?.facets_stats[facetName];

  if (!facetStats) {
    return undefined;
  }

  return facetStats;
};

export default getFacetStats;
